import { render, staticRenderFns } from "./DemoPageCslPlayer.vue?vue&type=template&id=d49e005a&scoped=true&"
import script from "./DemoPageCslPlayer.vue?vue&type=script&lang=js&"
export * from "./DemoPageCslPlayer.vue?vue&type=script&lang=js&"
import style0 from "./DemoPageCslPlayer.vue?vue&type=style&index=0&id=d49e005a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49e005a",
  null
  
)

export default component.exports